import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_ENDPOINTS } from '../../config/api';

export function Verify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('Token invalid sau lipsă');
      setVerifying(false);
      return;
    }
    const tokenValue = token; // narrow type

    async function verifyToken() {
      try {
        const returnUrl = searchParams.get('return');
        let url = `${API_ENDPOINTS.verify}?token=${encodeURIComponent(tokenValue)}`;
        if (returnUrl) {
          url += `&return=${encodeURIComponent(returnUrl)}`;
        }
        
        const res = await fetch(url, {
          headers: { 'Accept': 'application/json' },
        });
        const data = await res.json();
        
        if (data.success) {
          // Store session in localStorage
          localStorage.setItem('brainmap_session', data.session);
          // Navigate to the correct dashboard
          const target = data.role === 'PARTNER' ? '/dashboard' : '/admin/dashboard';
          navigate(target);
        } else {
          setError(getErrorMessage(data.reason));
        }
      } catch (err) {
        setError('Eroare la verificare. Încearcă din nou.');
      } finally {
        setVerifying(false);
      }
    }

    verifyToken();
    
    // Note: The page will navigate away, so we won't reach here
  }, [searchParams, navigate]);

  function getErrorMessage(reason: string): string {
    switch (reason) {
      case 'expired_or_used': return 'Link-ul a expirat sau a fost deja utilizat.';
      case 'invalid_token': return 'Token invalid.';
      case 'inactive': return 'Contul este inactiv.';
      case 'not_found': return 'Utilizator negăsit.';
      default: return 'Verificarea a eșuat.';
    }
  }

  if (verifying) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal mx-auto mb-4"></div>
          <p className="text-muted">Se verifică link-ul...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <h1 className="text-2xl font-serif text-red-600 mb-4">Eroare</h1>
          <p className="text-muted mb-6">{error}</p>
          <button
            onClick={() => navigate('/auth/login')}
            className="w-full py-3 px-4 bg-teal text-white font-medium rounded-lg hover:bg-teal-light transition-colors"
          >
            Înapoi la login
          </button>
        </div>
      </div>
    );
  }

  return null;
}
